const CANVAS_SCALE_FACTOR = 20;

export default CANVAS_SCALE_FACTOR;
